import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useCurrentUserV4 = () => {
  useReduxAction(
    'currentUserV4',
    'loadCurrentUserV4',
    {},
    [],
    {
      shouldPerformFn: (entityReducer) => {
        const { errors, loaded, loading } = entityReducer
        return !loaded && !loading && !errors.length
      },
    },
  )

  const entityReducer = useSelector(reduxState => reduxState.currentUserV4)
  const {
    loaded,
    loading,
    result: currentUserV4,
  } = entityReducer

  return {
    currentUserV4,
    loaded,
    loading,
  }
}

export default useCurrentUserV4
